module.exports = __webpack_public_path__ + "static/media/loadedMiles.3b96ec3f.svg";